export const SEASON_CATEGORY_NAME = 'Hooajakaubad'
